import {blockSmallIconsSliderScript } from '../../blocks/nh-slider-logo/script';
import {blockOpinionsGfSliderScript } from '../../blocks/opinions-gf/script';
import {blockTrainersSliderScript } from '../../blocks/trainers/script';

if(document.querySelector('.NH-blockSmallIconSlider')) {blockSmallIconsSliderScript()};
if(document.querySelector('.NH-blockOpinionsGFSlider')) {blockOpinionsGfSliderScript()};
if(document.querySelector('.NH-blockTrainersSlider')) {blockTrainersSliderScript()};